// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "#login-logo[data-v-61dd7a3d] {\n  height: auto;\n  max-width: 100%;\n  max-height: 38px;\n}", ""]);
// Exports
module.exports = exports;
